<template>
  <main class="auth-experience">
    <router-link to="/" class="auth-brand" aria-label="Voltar para a página inicial da Sanvault">
      <img src="../../assets/images/home/favicon.png" alt="">
      <span>Sanvault</span>
    </router-link>

    <section class="auth-value-panel">
      <div class="auth-value-panel__content">
        <span class="auth-kicker">E-mail enviado</span>
        <h1>As instruções já estão a caminho.</h1>
        <p>
          Verifique sua caixa de entrada e siga o processo indicado para recuperar
          o acesso à plataforma.
        </p>
        <div class="auth-value-list">
          <span><i class="ph ph-envelope-open"></i> Consulte também a caixa de spam</span>
          <span><i class="ph ph-clock"></i> O envio pode levar alguns instantes</span>
          <span><i class="ph ph-shield-check"></i> Link individual e protegido</span>
        </div>
      </div>
    </section>

    <section class="auth-form-panel" aria-label="Confirmação do envio">
      <ForgotPasswordSendEmail />
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import ForgotPasswordSendEmail from "../../components/Authentication/ForgotPasswordSendEmail.vue";

export default defineComponent({
  name: "ForgotPasswordPage",
  components: {
    ForgotPasswordSendEmail,
  },
});
</script>
